import React from 'react';
import { reduxForm } from 'redux-form';

// @ts-ignore
import SuperFormWizard from '@shorelight/super-form/components/SuperFormWizard';

import { FORM_NAME } from '../../constants';

const SuperFormWizardComponent = props => {
  return <SuperFormWizard {...props} />;
};

const ReduxSuperForm = reduxForm({
  form: FORM_NAME,
  enableReinitialize: true,
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true
})(SuperFormWizardComponent);

export default ReduxSuperForm;
